import React, { FC, memo, Dispatch, SetStateAction } from 'react'
import Ctd from 'react-countdown'
import { icons } from '../../lib/icons'


type CountdownProps = {
    classes: string
    setNavigateSlug?: Dispatch<SetStateAction<string>>
    eventState:string
    data: any
}

const Countdown: FC<CountdownProps> = ({ classes, eventState, data }) => {
    return (
        <>
        {eventState === 'prepare' ? 
            <div className="event-state-content" style={{
              borderLeftColor:`${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`,
              color: `${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`
              }}>
                课程准备中
                <div className="event-state-content-icon">{icons.prepare()}</div>
            </div> 
            :
        eventState === 'live' ? 
            <div className="event-state-content" style={{ 
                borderLeftColor:`${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`,
                color: `${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`}}>
                课程直播中
                <div className="event-state-content-icon">{icons.play()}</div>
            </div> 
            :
        eventState === 'recap' ? 
            <div className="event-state-content" style={{ 
                borderLeftColor:`${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`,
                color: `${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`}}>
                课程结束
            </div> 
                :
                    <>
                        {data && (
                            <Ctd
                            date={Date.parse(data[0].attributes.startTime)}
                                intervalDelay={0}
                                renderer={({ days, hours, minutes, seconds }) => {
                                    return (
                                        <div className={classes}>
                                            <time>
                                                <span className="landing-page-count-col">
                                                    <span className="landing-page-count-down-d count-down-num" style={{ background: `no-repeat url(${data && data[0]?.attributes?.landing_config?.img_o || 'https://oss.uppmkt.com/202302/ads/w/o.svg'})`}}>{days}</span>
                                                    <span
                                                        className="landing-page-count-down-word home-non"
                                                        id="landing-page-count-down-days"
                                                    >
                                                        日
                                                    </span>
                                                </span>
                                                <span className="landing-page-count-col">
                                                    <span className="landing-page-count-down-h count-down-num" style={{ background: `no-repeat url(${data && data[0]?.attributes?.landing_config?.img_o || 'https://oss.uppmkt.com/202302/ads/w/o.svg'})`}}>{hours}</span>
                                                    <span
                                                        className="landing-page-count-down-word home-non"
                                                        id="landing-page-count-down-hours"
                                                    >
                                                        时
                                                    </span>
                                                </span>
                                                <span className="landing-page-count-col">
                                                    <span className="landing-page-count-down-m count-down-num" style={{ background: `no-repeat url(${data && data[0]?.attributes?.landing_config?.img_o || 'https://oss.uppmkt.com/202302/ads/w/o.svg'})`}}>{minutes}</span>
                                                    <span
                                                        className="landing-page-count-down-word home-non"
                                                        id="landing-page-count-down-mins"
                                                    >
                                                        分
                                                    </span>
                                                </span>
                                                <span className="landing-page-count-col">
                                                    <span className="landing-page-count-down-s count-down-num" style={{ background: `no-repeat url(${data && data[0]?.attributes?.landing_config?.img_o || 'https://oss.uppmkt.com/202302/ads/w/o.svg'})`}}>{seconds}</span>
                                                    <span
                                                        className="landing-page-count-down-word home-non"
                                                        id="landing-page-count-down-secs"
                                                    >
                                                        秒
                                                    </span>
                                                </span>
                                            </time>
                                        </div>
                                    )
                                }}
                            />
                        )}
                    </>
        
        }
    </>
)
}

export default memo(Countdown)
